import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection() {
  return (
    <section className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="cta-section">
      <div className="relative overflow-hidden rounded-sm glass-strong p-10 md:p-16">
        <div className="absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-[radial-gradient(circle,rgba(56,189,248,0.25),transparent_60%)]" aria-hidden />
        <div className="absolute -bottom-24 -left-24 w-[480px] h-[480px] rounded-full bg-[radial-gradient(circle,rgba(255,107,74,0.18),transparent_60%)]" aria-hidden />
        <div className="relative grid grid-cols-12 gap-8 items-center">
          <div className="col-span-12 md:col-span-8">
            <p className="overline">Make The Call</p>
            <h3 className="font-display font-light text-3xl md:text-5xl tracking-tight mt-4 max-w-3xl leading-[1.05]">
              Bring the ambition. <span className="italic text-[var(--pov-cyan)]">We bring the velocity.</span>
            </h3>
            <p className="mt-6 max-w-2xl text-white/65 text-sm md:text-base leading-relaxed">
              Complimentary intro or premium session — both lock this week. No decks, no detours,
              just the next move.
            </p>
          </div>
          <div className="col-span-12 md:col-span-4 flex md:justify-end">
            <Link to="/book" className="btn-primary" data-testid="cta-book-btn">
              Book The Call <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
